import { cn } from '@/lib/utils';

/**
 * Bower logo — the official Bower spiral "B" icon mark on a fixed WHITE rounded
 * tile (with a subtle ring) so it stays consistent and crisp on BOTH light and
 * dark themes.
 * - `mark` (boolean): show ONLY the icon tile (used when space is tight).
 * - `invert` (boolean): on dark/colored backgrounds — only tweaks the sub-label colour.
 */
export const Logo = ({ className, mark = false, invert = false }) => {
  return (
    <div className={cn('flex items-center gap-2.5 select-none', className)}>
      <span className="inline-flex items-center justify-center bg-white rounded-xl shadow-sm ring-1 ring-black/10 h-11 w-11 p-1 shrink-0">
        <img
          src="/bower-icon.png"
          alt="Bower"
          className="h-full w-full object-contain"
          draggable="false"
        />
      </span>
      {!mark && (
        <span
          className={cn(
            'font-grotesk text-[10px] uppercase tracking-[0.18em] hidden sm:inline',
            invert ? 'text-white/70' : 'text-muted-foreground',
          )}
        >
          Founder OS
        </span>
      )}
    </div>
  );
};

export default Logo;
